<template>
  <div
    v-if="!pulseUser && latestChangelog"
    class="sf-row sf-pad-2"
    :class="
      usingNewLayout
        ? 'tw-bg-sf-info-subtle-1 tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-b tw-border-sf-slate-lighter-1'
        : 'sf-bg-snow-dark'
    "
  >
    <div class="sf-col">
      <div class="sf-level sf-level-center">
        <div class="sf-pad-r-6">
          <span class="sf-label sf-label-primary">{{ label }}</span>
          <span class="sf-fwdb sf-font-m sf-pad-l-2">{{
            latestChangelog
          }}</span>
        </div>

        <div>
          <a
            :href="changelogUrl"
            target="_blank"
            class="sf-a sf-a-primary sf-fwdb"
            @mouseup="markAsRead"
            >{{ I18n.t('shared.read_more') }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { isUsingNewLayout } from '@app/adapters/silverfin'

export default {
  computed: {
    ...mapState({
      hasNewChangelog: 'hasNewChangelog',
      latestChangelog: 'latestChangelog',
      pulseUser: 'pulseUser',

      label: (state) => {
        if (state.hasNewChangelog) {
          return state.changelogCategory
        } else {
          return 'Changelog'
        }
      },
    }),

    ...mapGetters(['changelogUrl']),

    usingNewLayout() {
      return isUsingNewLayout()
    },
  },

  created() {
    this.updateChangelog()
  },

  methods: {
    ...mapActions(['updateChangelog', 'markAsRead']),
  },
}
</script>
